import { Box, Chip, Container, Grid, Stack, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useLoaderData } from 'react-router-dom';
import noImage from './no_image.png';
import Spot from '../Spot/Spot';

const Profile = () => {
  const theme = useTheme();
  const isLargeUp = useMediaQuery(theme.breakpoints.up('lg'));
  const isMediumDown = useMediaQuery(theme.breakpoints.down('md'));
  const user = useLoaderData();

  return (
    <Box sx={{
      display: 'flex',
      marginTop: '1rem'
    }}>
      <Container>
        <Stack key={user.id} direction={isLargeUp ? 'row' : 'column'} spacing={2}>
          <img
            src={user.profile_photo_url || noImage}
            alt={user.name}
            style={{
              maxHeight: 500,
              maxWidth: 500,
              ...(isMediumDown && {
                maxHeight: '100%',
                maxWidth: '100%'
              })
            }}
          />
          <Box>
            <Grid container sx={{ textAlign: 'left' }}>
              <Grid item xs={12}>
                <Typography variant="h4">{user.name || 'User Name'}</Typography>
              </Grid>
              {Object.entries(user.categories).map(([category, values]) => {
                return (
                  <Grid key={category + 'category'} item xs={12}>
                    <div key={category + '_category'}>
                      <Typography variant="h5" sx={{
                        marginBottom: '1rem',
                        marginTop: '1rem'
                      }}>{category}</Typography>
                      {values.map(value => (
                        <Chip key={value + '_category_item'} label={value} sx={{
                          marginRight: '0.5rem'
                        }} />
                      ))}
                    </div>
                  </Grid>
                );
              })}
            </Grid>
            <Box sx={{ height: '1rem' }} />
            <Spot.Content spot={user} hideProfileButton />
          </Box>
        </Stack>
        <Typography variant="h5" sx={{
          marginBottom: '1rem',
          marginTop: '1rem'
        }}>Mottagningar</Typography>
        {user.receptions.map(spot => (
          <Stack key={spot.id} direction={isLargeUp ? 'row' : 'column'} spacing={2} sx={{
            marginTop: '1rem'
          }}>
            <Box>
              <Spot.Header spot={spot} />
              <Box sx={{ height: '1rem' }} />
              <Spot.Content spot={spot} hideProfileButton />
            </Box>
          </Stack>
        ))}
      </Container>
    </Box>
  );
};

export default Profile;
